export interface Result {
  Message?: string;
  MessageId: number;
  Status: ResultStatus
}

export enum ResultStatus {
  Accepted = 'A',
  Rejected = 'R',
  Unauthorized = 'U'
}
